var render = function render(){var _vm=this,_c=_vm._self._c;return _c('VSection',{attrs:{"large":"","label":"transactions.bundle_information_headline"}},[_c('VBundlePurchase',{attrs:{"transaction-details":_vm.transactionDetails}}),_c('VBundleUsage',{attrs:{"transaction-details":_vm.transactionDetails}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }